import React from "react";
import Svg from "../Svg";
import { SvgProps } from "../types";

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 24 24" {...props}>
      <path d="M19.6858 9.17882H11.908V1.40104C11.908 0.789064 11.4089 0.289932 10.7969 0.289932C10.1849 0.289932 9.68576 0.789064 9.68576 1.40104V9.17882H1.90799C1.29601 9.17882 0.796875 9.67795 0.796875 10.2899C0.796875 10.9019 1.29601 11.401 1.90799 11.401H9.68576V19.1788C9.68576 19.7908 10.1849 20.2899 10.7969 20.2899C11.4089 20.2899 11.908 19.7908 11.908 19.1788V11.401H19.6858C20.2977 11.401 20.7969 10.9019 20.7969 10.2899C20.7969 9.67795 20.2977 9.17882 19.6858 9.17882Z" />
    </Svg>
  );
};

export default Icon;
